import {useTranslation} from 'react-i18next';

import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material';

import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';
import {greenColors} from '../../../../layouts/theme/designSystem';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isCreatingMatch: boolean;
  canConfirmCreateMatch: boolean;
  poolMatchNote: string;
  onPoolMatchNoteChange: (nextNote: string) => void;
};

export const TalentPoolApplicationMatchDialog = ({
  open,
  onClose,
  onConfirm,
  isCreatingMatch,
  canConfirmCreateMatch,
  poolMatchNote,
  onPoolMatchNoteChange,
}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'talentPoolProfilePage.applicationCard'});

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm' aria-labelledby='create-pool-match-dialog-title'>
      <DialogTitle id='create-pool-match-dialog-title'>{t('createMatchDialogTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{mb: 1.5, color: greenColors[100]}}>
          {t('createMatchDialogDescription')}
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          value={poolMatchNote}
          onChange={(e) => onPoolMatchNoteChange(e.target.value)}
          label={t('createMatchDialogFieldLabel')}
        />
      </DialogContent>
      <DialogActions sx={{px: 3, pb: 2}}>
        <EmpionButton type='button' variant='secondary' onClick={onClose} disabled={isCreatingMatch}>
          {t('createMatchDialogCancel')}
        </EmpionButton>
        <EmpionButton type='button' variant='primary' onClick={onConfirm} disabled={!canConfirmCreateMatch}>
          {t('createMatchDialogConfirm')}
        </EmpionButton>
      </DialogActions>
    </Dialog>
  );
};
